// import external dependencies
import 'jquery';
import 'bootstrap';
import './vendor/jquery.easing.min';
import './vendor/keyshape';
import './vendor/modernizr-custom';
import './vendor/history';

import './util/get-url-parameter';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import singleUnit from './routes/single-unit';
import pageTemplateAppointment from './routes/page-template-appointment';

//Components
import buttons from './components/buttons';
import navigation from './components/navigation';
import loadingBar from './components/loading-bar';
import scrollReveal from './components/scroll-reveal';
import scrollTo from './components/scroll-to';
import footer from './components/footer';
import googleAnalytics from './components/google-analytics';
import pageTransition from './components/page-transition';
import popup from './components/popup';

//Blocks
import columns from './blocks/columns';
import contactAppointment from './blocks/contact-appointment';
import video from './blocks/video';
import form from './blocks/form';
import mediaText from './blocks/media-text';
import habitations from './blocks/habitations';
import gallery from './blocks/gallery';
import units from './blocks/units';
import faq from './blocks/faq';
import file from './blocks/file';
import initMap from './blocks/map';
/**
 * Run on first page load and subsequent ajax page loads
 */
function initPage() {
  /** Populate Router instance with DOM routes */
  const routes = new Router({
    common,
    home,
    singleUnit,
    pageTemplateAppointment,
  });

  //Init blocks
  columns();
  contactAppointment();
  video();
  form();
  mediaText();
  habitations();
  gallery();
  // initMap();
  units();
  faq();
  file();

  //Init components
  // scrollReveal();
  scrollTo();
  buttons();
  footer();
  pageTransition();
  popup();

  // Load Events
  jQuery(document).ready(() => routes.loadEvents());


  // add document ready and wait for the initMap function to be defined and window.belleriveMap to be defined
  document.addEventListener('DOMContentLoaded', function() {
    if ( typeof window.belleriveMap !== 'undefined') {
      initMap();
    }
  });


}

/**
 * Run only once
 */
navigation();
initPage();
googleAnalytics();

/**
 * Add class to body for development
 */
if (location.hostname === 'localhost') {
  $('body').addClass('localhost');
}
